import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, Repository } from 'typeorm';
import { getMyNetworkResponseModel } from '../profile/dto/profile-response-model';
import { ProfileService } from '../profile/profile.service';
import { UserEntity } from '../user/user.entity';
import { HierarchyDTO } from './dto/hierarchy.dto';
import { HierarchyEntity } from './hierarchy.entity';


@Injectable()
export class HierarchyService {
    constructor(
        @InjectRepository(HierarchyEntity)
        private hierarchyRespository:Repository<HierarchyEntity>,
        @InjectRepository(UserEntity)
        private userRepo:Repository<UserEntity>,
        private profileService: ProfileService,
    ){}
    
    async linkHierarchy(hierarchyData) {
        try{
            const savedHierarchy = await this.hierarchyRespository.save(hierarchyData);
            if(savedHierarchy){
                return savedHierarchy;
            } else {
                return null;
            }
        }  catch(error){
            throw error;
        }
    }

    async getMyNetworkByUserId(queryParams, userId, request:Request):Promise<getMyNetworkResponseModel> {
        const response = new getMyNetworkResponseModel();
        try {
            const data = await getConnection()
            .createQueryBuilder()
            .select("User.Id,User.role_id,User.mobile_no,User.emaill,roles.role_name,profile.first_name,profile.profile_pic")
            .from(UserEntity, "User")
            .leftJoinAndSelect('User.roles','roles')
            .leftJoinAndSelect('User.profile','profile')
            .where('User.status=:da', { da: true})
            .orderBy('profile.first_name','ASC')
            .getRawMany();
            const finData: any[] = [];
            if(queryParams.apiVersion == 1) {
                if(data) {
                    const promises = data.map(async (lev) => {
                            return {
                                userId:lev.id,
                                userName: lev.first_name,
                                profilePic:lev.profile_pic,
                                roleId:lev.role_id,
                                roleName:lev.role_name,
                                mobileNo: lev.mobile_no,
                                email:lev.emaill
                            }                    
                    });
                    const uda = await Promise.all(promises);
                    uda.map((u) => {
                        finData.push({
                            userId:u.userId,
                            userName:u.userName != null ? u.userName:'',
                            profilePic: u.profilePic != null ? `${process.env.WORKINGURL}/${u.profilePic}` : '',
                            mobileNo:u.mobileNo !=null?u.mobileNo:'',
                            email:u.email !=null?u.email:'',
                            roleId:u.roleId,
                            roleName:u.roleName
                        })
                    })
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                if(data) {
                    const promises = data.map(async (lev) => {
                            return {
                                userId:lev.id,
                                userName: lev.first_name,
                                profilePic:lev.profile_pic,
                                roleId:lev.role_id,
                                roleName:lev.role_name,
                                mobileNo: lev.mobile_no,
                                email:lev.emaill
                            }                    
                    });
                    const uda = await Promise.all(promises);
                    uda.map((u) => {
                        finData.push({
                            userId:u.userId,
                            userName:u.userName != null ? u.userName:'',
                            profilePic: u.profilePic != null ? `${process.env.WORKINGURL}/${u.profilePic}` : '',
                            mobileNo:u.mobileNo !=null?u.mobileNo:'',
                            email:u.email !=null?u.email:'',
                            roleId:u.roleId,
                            roleName:u.roleName
                        })
                    })
                    if(finData.length > 0) { 
                        response.status = true;
                        response.data = finData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Data retrieved successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Data not found');
                    }
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;           
        } catch (error) {
            throw error;
        }
    }
}
